import {AppHelper} from "../../appHelper";
import {HTTPService, JsonResultClass} from "../../core/util/httpManager";
import {NotificationHelper} from "../../core/util/notificationHelper";
import {AppBaseProps, CommonApp, Context, Entity, Metadata} from "../../core/components/commonApp";
import {Helper} from "../../core/util/helper";
import {ExecutionInfoItem} from "./recurringTaskHistory";
import ExecutionsApp, {ExecutionFilter, ExecutionsAppProps, ExecutionsEntity} from "./executions";
import {General} from "../../../siteManagement/general";
import {SheetEventType} from "../../../siteManagement/sheet";
import AssignmentsGridApp from "./assignmentGrid";
import ExecutionsGridApp, {ExecutionGridEntity} from "./executionsGrid";
import {BaseColumn, EditableGrid, field, Schema} from "../../core/components/editableGrid/editableGrid";
import {IngridHelper} from "../../core/util/ingridHelper";
import GridOptions = kendo.ui.GridOptions;
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class ExecuteAllAppLauncher extends React.Component<ExecuteAllAppLauncherProps, ExecuteAllAppLauncherState> {
    constructor(props: ExecuteAllAppLauncherProps) {
        super(props);
        this.state = {
            initialized: false
        };
    }

    initialize = async () => {
        let result = await HTTPService.get<JsonResultClass<ExecuteAllEntity>>('TriggerExecution/InitExecuteAll');
        if (result.Code > 0) {
            NotificationHelper.showErrorMessage(result.Message);
            return;
        }
        let metadataUrl = result.Data.TriggerInBackground ? "executeAllTasksBackground" : "executeAllTasks";

        let metadata = await Helper.getMetaData(metadataUrl);

        let entity = result.Data;
        if (this.props.forwardingToAllExecutionsEnabled != null)
            entity.ForwardingToAllExecutionEnabled = this.props.forwardingToAllExecutionsEnabled;
        if (this.props.entityPreallocation != null)
            entity.Filter = this.props.entityPreallocation(entity.Filter);
        this.setState({initialized: true, metadata, entity});
    }

    componentDidMount() {
        this.initialize().then(() => {
        });
    }

    renderExecutionApp = (): React.ReactNode => {
        const props: ExecuteAllProps = {
            context: {
                contextType: "executeAll"
            },
            title: Helper.getTranslation("WebCRM.Tasks.ExecuteAll.ScheduleIntervalls"),
            entity: this.state.entity,
            metadata: this.state.metadata,
            dataSources: {},
            isWindow: this.props.isWindow,
            afterTriggerAllExecutions: this.props.afterTriggerAllExecutions
        };

        return <ExecuteAllTasksApp {...props} />;
    }

    render() {
        return this.state.initialized ? this.renderExecutionApp() : null;
    }
}

export interface ExecuteAllAppLauncherProps {
    isWindow: boolean,
    afterTriggerAllExecutions?: (triggeredInfo: TriggeredInfo) => void;
    entityPreallocation?: (filter: FilterEntity) => FilterEntity;
    forwardingToAllExecutionsEnabled?: boolean
}

interface ExecuteAllAppLauncherState {
    initialized: boolean
    metadata?: Metadata
    entity?: ExecuteAllEntity
}

class ExecuteAllTasksApp extends React.Component<ExecuteAllProps, ExecuteAllState> {
    common = new AppHelper();
    private executionsGridRef: ExecutionsGridApp;
    private assignmentsGidRef: AssignmentsGridApp;
    skippedTasksGridOptions: {};
    executedTasksGridOptions: {};
    createdAssignmentGridOptions: {};
    machineGridOptions: {};
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    deleteEnabled: boolean = false;
    isDeleted: boolean;
    translations: StringKeyDictionary<string> = null;
    tasksToTriggerGridRef: TasksToTriggerInGrid;
    tasksToTriggerGridOptions: GridOptions;

    constructor(props: ExecuteAllProps) {
        super(props);
        this.state = {
            tasksShown: false,
            tasksRetrieved: false,
            tasksSelected: false,
            tasksToTrigger: [],
            selectedExecution: null,
            filterAssignments: false
        } 
        this.common.init(this);
    }

    // noinspection JSUnusedGlobalSymbols
    openExecutions = async () => {
        let result = await Promise.all([HTTPService.get<JsonResultClass<ExecutionsEntity>>('Executions/Init'), Helper.getMetaData("executions")]);
        const entity = result[0];
        entity.Data.ExecutionFilter = this.getExecutionFilter();
        entity.Data.ForwardingToPreScheduleEnabled = false;

        if (entity.Code > 0) {
            NotificationHelper.showErrorMessage(entity.Message);
        } else {
            this.openSheet(entity, result[1]);
        }
    }

    private openSheet(entity: JsonResultClass<ExecutionsEntity>, metadata: Metadata) {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(Helper.getTranslation("Field.fstasks.ShowExecutions"));
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.setState({}, () => {
                this.common.sheetWrapper.trigger(SheetEventType.Custom, {event: "Reloading"});
            });
        });
        sheet.show(() => {
            const props: ExecutionsAppProps = {
                context: {
                    contextType: "executions"
                },
                title: Helper.getTranslation("Field.fstasks.ShowExecutions"),
                entity: entity.Data,
                metadata: metadata,
                dataSources: {},
                isWindow: true
            };

            sheet.mountContent(ExecutionsApp, props);
        });
    }

    componentDidMount() {
        this.props.context.skippedTasksGridOptions = this.skippedTasksGridOptions;
        this.props.context.executedTasksGridOptions = this.executedTasksGridOptions;
        this.props.context.createdAssignmentGridOptions = this.createdAssignmentGridOptions;
    }


    handleFieldChange = (field: { model: any; }, value: any, dataItem = null, isInit = false) => {
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
            this.common.setEntityDirtyState(false);
        }
    }

    getExecutionFilter = (): ExecutionFilter => {
        return {
            End: this.props.entity.Filter.TillDate,
            AdrNr: this.props.entity.Filter.AddrNo,
            ProjNr: this.props.entity.Filter.ProjNo,
            TaskNo: this.props.entity.Filter.TaskNo,
            OGrNrs: this.props.entity.Filter.OGrNrs,
            OnlyActive: false,
            Start: null,
            IndividualFields: this.props.entity.Filter.IndividualFields
        };
    }

    // noinspection JSUnusedGlobalSymbols
    renderExecutionsGridApp = () => {
        let entity: ExecutionGridEntity = {
            ExecutionMgmtEnabled: this.props.entity.ExecutionMgmtEnabled,
            IsNew: this.props.entity.IsNew,
            IsWatchable: this.props.entity.IsWatchable,
            IsWatched: this.props.entity.IsWatched,
            RecordRight: this.props.entity.RecordRight,
            IndividualFields: this.props.entity.IndividualFields
        };
        let context = {
            executionGridOptions: this.executedTasksGridOptions,
            translations: this.translations
        };
        return <div style={{height: "400px"}}>
            <ExecutionsGridApp entity={entity} context={context} ref={(ref) => this.executionsGridRef = ref}
                               assignmentsGridRef={this.assignmentsGidRef}
                               gridData={this.props.entity.ExecutedAllResult.ExecutedInfos} onSetParentState={() => {
                this.setState({})
            }}/>
        </div>;
    }

    // noinspection JSUnusedGlobalSymbols
    renderAssignmentsGridApp = () => {
        const entity: Entity = {
            IsNew: this.props.entity.IsNew,
            IsWatchable: this.props.entity.IsWatchable,
            IsWatched: this.props.entity.IsWatched,
            RecordRight: this.props.entity.RecordRight,
            IndividualFields: this.props.entity.IndividualFields
        };
        const context = {
            assignmentGridOptions: this.createdAssignmentGridOptions,
            translations: this.translations
        };
        return <div style={{height: "400px"}}>
            <AssignmentsGridApp entity={entity} context={context} ref={(ref) => this.assignmentsGidRef = ref}
                                executionsGridRef={this.executionsGridRef} onLoaded={() => {
                this.setState({})
            }}/>
        </div>;
    }


    handleClickCustomButton = (id: string) => {
        if (id === "showAll") {
            this.setState({selectedExecution: null, filterAssignments: false});
        }
    }

    // noinspection JSUnusedGlobalSymbols
    createTasksToTriggerGrid = () => {
        return (
            <TasksToTriggerInGrid
                tasksToTrigger={this.state.tasksToTrigger}
                gridOptions={this.tasksToTriggerGridOptions}
                entity={this.props.entity}
                onSelectionChange={this.selectedTasksToTriggerChanged}
                ref={(ref) => this.tasksToTriggerGridRef = ref}/>);
    }
    
    // noinspection JSUnusedGlobalSymbols
    retrieveTasksToTrigger = async () => {
        let tasksToTriggerResponse = await HTTPService.post<JsonResultClass<TaskToTriggerEntity[]>>("TriggerExecution/GetTasksToTrigger", this.props.entity.Filter)
        if (tasksToTriggerResponse.Code != 0) {
            NotificationHelper.showErrorMessage(tasksToTriggerResponse.Message);
            return;
        }
        
        let tasksToTrigger = tasksToTriggerResponse.Data;
        for(let t of tasksToTrigger)
        {
            t.selected = true;
        }
        this.setState({ 
            tasksRetrieved: true,
            tasksShown: tasksToTrigger.length > 0,
            tasksSelected: tasksToTrigger.length > 0,
            tasksToTrigger: tasksToTrigger 
        });
    }
    
    // noinspection JSUnusedGlobalSymbols
    triggerSelectedTasks = async () => {
        let tasks = this.tasksToTriggerGridRef.getSelectedTasks();
        tasks = tasks.map((v) => { return {...v, TriggeredTill: Helper.dates.getISODateString(v.TriggeredTill, true), TargetTill:  Helper.dates.getISODateString(v.TargetTill, true)} });
        let request = HTTPService.post<JsonResultClass>("TriggerExecution/ScheduleTriggering", 
            tasks);
        let result = await request;
        if (result.Code != 0)
            NotificationHelper.showErrorMessage(result.Message);
        let updatedTasksToTrigger = this.state.tasksToTrigger.filter(t => tasks.find(tt => tt.TaskNo == t.TaskNo) == null)
        this.setState({ 
            tasksShown: updatedTasksToTrigger.length > 0,
            tasksSelected: updatedTasksToTrigger.length > 0, 
            tasksToTrigger: updatedTasksToTrigger});
    }
    
    selectedTasksToTriggerChanged = () => {
        let tasks = this.tasksToTriggerGridRef.getSelectedTasks();
        let selectionNotEmpty = tasks.length > 0;
        if (this.state.tasksSelected != selectionNotEmpty)
            this.setState({ tasksSelected: selectionNotEmpty });
    }
    
    // noinspection JSUnusedGlobalSymbols
    tasksRetrieved = () => { return this.state.tasksRetrieved; };
    // noinspection JSUnusedGlobalSymbols
    tasksShown = () => { return this.state.tasksShown; };
    // noinspection JSUnusedGlobalSymbols
    tasksSelected = () => { return this.state.tasksSelected; };

    // noinspection JSUnusedGlobalSymbols
    triggerAllExecutions = async () => {
        let triggerAllResult = await HTTPService.post<JsonResultClass<TriggeredInfo>>("TriggerExecution/TriggerAllExecutions", this.props.entity.Filter);
        if (triggerAllResult.Code === 0) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.ExecuteAll.SuccessfulExecuted"));
            let data = triggerAllResult.Data;
            let initResult = await HTTPService.get<JsonResultClass<ExecuteAllEntity>>("TriggerExecution/InitExecuteAll");
            if (initResult.Code === 0) {
                initResult.Data.HasExecutedResult = true;
                initResult.Data.ExecutedAllResult = data;
                initResult.Data.Filter = this.props.entity.Filter;
                initResult.Data.ForwardingToAllExecutionEnabled = this.props.entity.ForwardingToAllExecutionEnabled;
                Helper.updateEntity(this.props.entity, initResult.Data);
                this.setState({}, () => {
                    if (Helper.hasValue(this.props.afterTriggerAllExecutions))
                        this.props.afterTriggerAllExecutions(data);
                });
            } else {
                NotificationHelper.showErrorMessage(initResult.Message);
            }
        } else {
            NotificationHelper.showErrorMessage(triggerAllResult.Message);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), {handleFieldChange: this.handleFieldChange});


        return (<CommonApp {...props} />);
    }
}

class TasksToTriggerInGrid extends React.Component<TasksToTriggerInGridProps, TasksToTriggerInGridState>{
    editableGridRef: EditableGrid;

    constructor(props: TasksToTriggerInGridProps) {
        super(props);
        this.state = {
            Columns: null,
            Schema: null
        }
    }

    componentDidMount() {
        new IngridHelper(this).initGridSettings(this.props.gridOptions).then(result => {
            let gridOptions = result;
            this.setState({
                Columns: gridOptions.Columns, Schema: gridOptions.Schema
            });
        });
    }

    getSelectedTasks = () => {
        let items = this.editableGridRef.getData();
        return items.filter((i) => i["selected"]);
    }

    render() {
        let content = null;
        if (this.state.Schema != null && this.state.Columns != null) {
            let schema = this.state.Schema;
            schema.Id = "TaskId";
            schema.fields["TaskId"] = new field("string");
            
            content = <EditableGrid {...this.props.gridOptions}
                                    id="tasksToTriggerGrid"
                                    editable={true}
                                    validatable={false}
                                    showSelectableCheckBox={false}
                                    data={this.props.tasksToTrigger}
                                    schema={this.state.Schema}
                                    columns={this.state.Columns}
                                    nextCellOnEnter={true}
                // resolveAdditionalData={() => { }} 
                                    onDataChanged={() => this.props.onSelectionChange()} 
                // onRequestItemValidation={this.onRequestItemValidation} 
                // entity={this.props.entity}
                                    //onSelectionChange={() => { this.props.onSelectionChange(); }}
                                    ref={(ref) => this.editableGridRef = ref}
                />
        }
        return content;
    }
}

interface TasksToTriggerInGridProps
{
    gridOptions: any
    tasksToTrigger: TaskToTriggerEntity[]
    entity: ExecuteAllEntity
    onSelectionChange: () => void
}

interface TasksToTriggerInGridState
{
    Columns: BaseColumn[];
    Schema: Schema;
}

interface TaskToTriggerEntity {
    selected: boolean;
    TaskId: string
    TaskNo: string
    TaskTitle: string
    TriggeredTill?: string | Date
    TargetTill: string | Date
    ErrorCount: number
}

interface FilterEntity {
    AddrNo: string;
    TillDate: string;
    ProjNo: string;
    TaskNo: string;
    OGrNrs: number[];
    IndividualFields: {}
}

export interface ExecuteAllEntity extends Entity {
    Filter: FilterEntity;
    ExecutedTill: string;
    ExecutedMax: string;
    ActiveTasksAmount: number;
    HasExecutedResult: boolean;
    ExecutedAllResult: TriggeredInfo;
    ExecutionMgmtEnabled: boolean;
    ForwardingToAllExecutionEnabled: boolean;
    TriggerInBackground: boolean;
}

export interface TriggeredInfo {
    TriggeredTasks?: number;
    TriggeredExecutions?: number;
    GeneratedAssignments: number;
    SkippedTasks?: number;
    TriggeredTill?: string;
    SkippedTasksInfos?: Array<SkippedInfos>;
    ExecutedInfos?: Array<ExecutionInfoItem>;
}

export interface SkippedInfos {
    TaskId: string;
    TaskTitle: string;
    ReasonText: string;
    Reason: number;
    TriggerTill: string;
}

interface ExecuteAllContext extends Context {
    skippedTasksGridOptions?: {}
    executedTasksGridOptions?: {}
    createdAssignmentGridOptions?: {}
}

interface ExecuteAllProps extends AppBaseProps {
    entity: ExecuteAllEntity;
    context: ExecuteAllContext;
    afterTriggerAllExecutions?: (triggeredInfo: TriggeredInfo) => void;
}

interface ExecuteAllState {
    selectedExecution: ExecutionInfoItem;
    filterAssignments: boolean;
    tasksRetrieved: boolean;
    tasksShown: boolean;
    tasksSelected: boolean;
    tasksToTrigger: TaskToTriggerEntity[]
}